
var dropzone = {

    init: function(container, options) {
        options.autoProcessQueue = (options.autoProcessQueue !== undefined ? options.autoProcessQueue : true);
        var uploadDropzone = new Dropzone(options.selector || "[data-dropzone]", {
            url: options.url,
            maxFilesize: 20000,
            autoProcessQueue: options.autoProcessQueue,
            uploadMultiple: options.uploadMultiple || false,
            dictDefaultMessage: container.attr('data-default-text') || '',
            createImageThumbnails: false,
            clickable: (options.clickable ? $(options.clickable)[0] : container.find('[data-dz-upload]')[0]),
            acceptedFiles: container.attr('data-acceptedfiles'),
            paramName: "File",
            previewTemplate: '<div class="modal dz-preview dz-file-preview" role="dialog">' +
              '  <div class="modal-dialog dz-details">' +
              '    <div class="modal-content">' +
              '      <div class="modal-header">' +
              '        <strong class="modal-title"><div class="dz-filename"><span data-dz-name></span><span class="dz-size" data-dz-size></span></div></strong>' +
              '      </div>' +
              '      <div class="modal-body">' +
              '        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
              '        <div class="dz-error-message"><span data-dz-errormessage></span></div>' +
              '      </div>' +
              '      <div class="modal-footer" style="display:none;">' +
              '      </div>' +
              '    </div>' +
              '  </div>' +
              '</div>',
            sending: function(file, xhr, formData) {
                container.startProcess();
                formData.append("repositoryId", container.attr('data-repositoryId'));
                formData.append("relationType", container.attr('data-relationType'));
                formData.append("relationId", container.attr('data-relationId'));
                if (options.onSending) options.onSending(file, xhr, formData);
            },
            addedfile: function (file) {
                if (options.autoProcessQueue) {
                    var uploadPreview = '<div data-upload="' + file.name + '">' +
                      '  <div class="progress">' +
                      '    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>' +
                      '  </div>' +
                      '  <span class="message">' + file.name + '</span>' +
                      '</div>';

                    toastr.info(uploadPreview, 'Upload ...', {
                        closeButton: true,
                        newestOnTop: false,
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                    var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                    uploadToast.find('.toast-close-button').hide().prop('disabled', 'disabled');
                }
            },
            uploadprogress: function (file, bytesSent) {
                $('#toast-container [data-upload="' + file.name + '"] .progress-bar').width(bytesSent + '%');
            },
            complete: function (file, message) {
                if (file.accepted) {
                    uploadDropzone.removeFile(file);
                }
                container.endProcess();
            },
            canceled: function (file, message) {
                debugger;
                uploadDropzone.removeFile(file);
            },
            error: function(file, data) {
                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-error');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);
                uploadToast.find('.toast-title').html('Fehler');
                uploadToast.find('.message').append('<br/>' + data.error);
            },
            success: function (f, responseText) {
                var file = responseText.file;
                container.trigger('file-added', { file: f, response: responseText });
                connection.handleResponse(responseText, options);

                var uploadToast = $('#toast-container [data-upload="' + file.name + '"]').closest('.toast');
                uploadToast.removeClass('toast-info').addClass('toast-success');
                uploadToast.find('.toast-close-button').show().prop('disabled', null);

                setTimeout(function () {
                    uploadToast.remove();
                }, 500);
            },
            queuecomplete: function() {
                if (options.onQueuecomplete) options.onQueuecomplete();
                container.endProcess();
            }
        });
        $(options.selector || "[data-dropzone]").data('dz', uploadDropzone);
    }
};
window.dropzone = dropzone;

$(document).on('content-ready', function(ev, container) {
    $.each(container.find('[data-upload-container]'), function() {
        var me = $(this);
        if (!me.attr('id')) {
            me.attr('id', 'dz' + Math.ceil(Math.random() * 200));
        }
        var options = {
            selector: '#' + me.attr('id') + ' [data-dropzone]',
            url: me.attr('data-upload-container'),
        };
        if (me.attr('auto-process-queue')) {
            options.autoProcessQueue = me.attr('auto-process-queue');
        }
        if (me.attr('data-multiple')) {
            options.uploadMultiple = true;
        }

        dropzone.init(me, options);
    });

    container.find('[data-askdelete]').click(ev => {
        var deleteBtn = $(ev.currentTarget);
        messaging.askYesNo(deleteBtn.attr('data-title') || 'Datei löschen?', deleteBtn.attr('data-question') || 'Willst du die Datei löschen?', function () {
            connection.loadJson(deleteBtn.attr('data-askdelete'), null, function () {
                messaging.showGlobalMessage('success', null, 'Die Datei wurde gelöscht.');
            }, function () {
                messaging.showPermanentGlobalMessage('danger', null, 'Die Datei konnte nicht gelöscht werden.');
            });
        });
        return false;
    });
});
